var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"feedback"}},[_c('el-tabs',{model:{value:(_vm.tabAction),callback:function ($$v) {_vm.tabAction=$$v},expression:"tabAction"}},_vm._l((_vm.tabs),function(item){return _c('el-tab-pane',{key:item.name,attrs:{"label":item.label,"name":item.name}})}),1),_c(_vm.tabAction,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }